import { makeStyles } from '~/UIKit/Style';
import { FONT_SIZE_MEDIUM_INBETWEEN, FONT_SIZE_LARGE } from '~/Constants/UI.constants';
import {
  CHARCOAL_GREY,
  GRAY_BACKGROUND,
  GRAY_USC,
  BORDER_COLOR,
} from '~/Constants/Colors.constants';

export const useStyles = makeStyles((theme) => ({
  groupLabelIcon: {
    width: 44,
    position: 'relative',
    zIndex: 99999,
  },
  sections: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
    height: '100%',
    marginBottom: 33,
    padding: '0 16px',
    [theme.breakpoints.up('md')]: {
      padding: '0',
    },
    '& >.MuiSelect-selectMenu': {
      display: 'flex',
      alignItems: 'center',
      width: 200,
    },
  },
  groupLabel: {
    fontWeight: '700',
    fontSize: FONT_SIZE_LARGE,
    marginBottom: 9,
    display: 'flex',
    flexdirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  consent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginTop: 24,
    padding: '0 16px',
    [theme.breakpoints.up('md')]: {
      padding: '0',
    },
  },
  consentBox: {
    padding: '4px 10px 0px 0px',
  },
  note: {
    display: 'flex',
    flexDirection: 'column',
    padding: '16px',
  },
  noteText: {
    fontSize: FONT_SIZE_MEDIUM_INBETWEEN,
    color: CHARCOAL_GREY,
  },
  billable: {
    height: 48,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '16px',
  },
  billableText: {},
  label: {
    fontWeight: '700',
    fontSize: FONT_SIZE_MEDIUM_INBETWEEN,
    color: CHARCOAL_GREY,
  },
  disabled: {
    backgroundColor: GRAY_BACKGROUND,
  },
  sectionContent: {
    margin: '0 -15px',
    [theme.breakpoints.up('md')]: {
      margin: '0',
    },
  },
  optional: {
    fontSize: FONT_SIZE_MEDIUM_INBETWEEN,
    color: GRAY_USC,
    fontWeight: '700',
  },
  customField: {
    fontSize: FONT_SIZE_MEDIUM_INBETWEEN,
    color: CHARCOAL_GREY,
    border: `1px solid ${BORDER_COLOR}`,
  },
}));
